<template>
    <form class="callback-form"
          :class="{'CKiForm': CONSTANTS.cKeeper === 'iform'}"
          ref="form"
          @submit.prevent="submitThis">
        <div class="controls">
            <input name=”tel” type="tel" :title="'Введите номер телефона'"
                   placeholder="Ваш телефон" v-model="phone" ref="phone" v-mask
                   :pattern="'.*[0-9]{1}.*[0-9]{3}.*[0-9]{3}.*[0-9]{4}'" required>
            <button class="button button_primary" type="submit"
                 :class="[{disabled: !acceptance},{'CKFormTrigger': CONSTANTS.cKeeper === 'iform'}]" ref="submitter">
                <slot></slot>
                {{$slots.default ? '' : 'ОТПРАВИТЬ ЗАЯВКУ'}}
            </button>
        </div>
        <div class="agreement" v-if="agreementVisible">
            <checkbox v-model="acceptance" />
            <a
              target="_blank"
              rel="noopener"
              href="https://avtomir.ru/agreement/"
              class="agreement-text"
            >
              Согласие на обработку персональных данных
            </a>
        </div>
    </form>
</template>

<script>
import Checkbox from "../checkbox.vue";
import Mask from "@/common/mask";
import Mixin from "@/common/mixin";

export default {
  name: "",
  components: { Checkbox },
  directives: { Mask },
  mixins: [Mixin],
  props: ["data", "agreed"],
  data() {
    return {
      acceptance: true,
      phone: "",
    };
  },
  computed: {
    agreementVisible() {
      if (this.agreed !== undefined) return this.agreed;
      else return this.CONSTANTS.need_agreement;
    },
  },
  methods: {
    submitThis() {
      if (
        this.$refs.phone.validity.valueMissing ||
        !this.$refs.phone.validity.valid
      ) {
        this.$refs.phone.setCustomValidity("Введите номер телефона");
      }
      if (
        !this.$refs.phone.validity.valueMissing &&
        !this.$refs.phone.validity.patternMismatch
      ) {
        this.$refs.phone.setCustomValidity("");
      }
      if (this.acceptance && this.$el.reportValidity()) {
        ym(99537255, "reachGoal", "send_form");
        this.$emit("callBack", {
          phone: this.phone,
          data: this.data,
        });
        if (
          this.CONSTANTS.cKeeper === "iform" &&
          typeof ckForms !== "undefined"
        ) {
          ckForms.send(this.$refs.form);
        }
      }
    },
    getAgreement() {
      this.$emit("getAgreement");
    },
  },
};
</script>

<style scoped lang="scss" src="./style.scss">
</style>
